<template>
  <div class="body-container">
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary">
        <v-card-text>
          <div class="loadTitle">
            <img :src="images.logo" /> <label>Cargando...</label>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <b-collapse
      class="card property show"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
        >
          <div class="property-title">
            <h3>
              <strong>Mi propiedad:</strong> {{ productoPrincipal.tipo }}
              {{ productoPrincipal.modelo }} Número
              {{ productoPrincipal.numero }}
            </h3>
          </div>
          <a class="card-header-icon">
            <font-awesome-icon v-if="props.open" :icon="['fa', 'chevron-up']" />
            <font-awesome-icon v-else :icon="['fa', 'chevron-down']" />
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <div class="property-title">
            <h3><strong>N° de Negocio:</strong>{{ project.negocio }}</h3>
          </div>
          <div class="property-buttonsGroup">
            <router-link
              :to="{
                name: 'detalle',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
            >
            <router-link
              :to="{
                name: 'estado-compra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'home']" />Estado de
              Compra</router-link
            >
            <router-link
              :to="{
                name: 'avance-obra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
              Obra</router-link
            >
            <router-link
              :to="{
                name: 'documentos',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'file']" />Documentos
              Negocio</router-link
            >
            <router-link
              :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
              ><font-awesome-icon
                :icon="['fa', 'dollar-sign']"
              />Pagos</router-link
            >
            <router-link
              :to="{
                name: 'documentos-propiedad',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'map']" />Documentos
              Propiedad</router-link
            >
          </div>
          <b-button
            class="change-btn"
            @click="isCardModalActive = true"
            v-if="proyectos.length > 1"
            ><font-awesome-icon :icon="['fa', 'exchange-alt']" />Cambiar de
            Propiedad</b-button
          >
        </div>
      </div>
      <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
        <div class="card">
          <div class="card-content">
            <div class="misPropiedades-title">
              <h2><span class="bricsa-square"></span>Mis Propiedades</h2>
            </div>
            <div class="misPropiedades-content">
              <div
                class="misPropiedades-item"
                v-for="(misPro, index) in proyectos"
                :key="index"
              >
                <img :src="misPro.image" />
                <label
                  >{{ misPro.productoPrincipal.tipo }}
                  {{ misPro.productoPrincipal.numero }} -
                  {{ misPro.proyecto }}</label
                >
                <h6>
                  <router-link
                    :to="{
                      name: 'avance-obra',
                      params: { idNegocio: misPro.idNegocio },
                    }"
                    ><strong>N° de negocio:</strong> {{ misPro.negocio }}
                    <i class="far fa-eye"></i
                  ></router-link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </b-collapse>

    <section class="avance">
      <div class="avance-title">
        <h2><span class="bricsa-square"></span>Avance de Compra</h2>
        <h2><span class="bricsa-square"></span>Seguimiento de la Obra</h2>
      </div>
      <div class="status">
        <div class="status-content">
          <div class="status-item" v-for="stat in status" :key="stat.id">
            <v-progress-circular
              indeterminate
              color="primary"
              v-show="project_wp.imagen == ''"
            ></v-progress-circular>
            <b-carousel
              class="bitacora"
              :autoplay="false"
              with-carousel-list
              :indicator="false"
              :overlay="gallery"
              @click="switchGallery(true)"
            >
                <b-carousel-item v-for="(item, i) in etapa.imagenes" :key="i">
                  <b-image class="image" :src="item.url"></b-image>
                </b-carousel-item>
                <template #indicators="props">
                    <b-image class="al image" :src="props.url" :title="props.url"></b-image>
                </template>
              <span
                v-if="gallery"
                @click="switchGallery(false)"
                class="modal-close is-large"
              />
              <template #list="props">
                <b-carousel-list
                  v-model="props.active"
                  :data="etapa.imagenes"
                  v-bind="al"
                  @switch="props.switch($event, false)"
                  as-indicator
                />
              </template>
              <template #overlay>
                <div class="has-text-centered has-text-white">
                  Hello, I'm an overlay!
                </div>
              </template>
            </b-carousel>

            <!-- <img :src="project_wp.imagen" class="loading" /> -->
            <div class="status-item__info">
              <div class="status-step">
                <strong>{{ project.etapaNav.avance }}%</strong>
                <label>{{ project.etapaNav.tituloDeAvance }}</label>
                <p>{{ project.etapaNav.detalleDeAvance }}</p>
              </div>
              <div class="status-date">
                <h2>Fecha estimada de entrega</h2>
                <h1>{{ project.etapaNav.periodoDeEntrega }}</h1>
              </div>
              <b-button class="change-btn" @click="estadoObra = true"
                >Anexo de seguimiento de avance</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="masInfo">
      <div class="masInfo-title">
        <h2>
          <span class="bricsa-square"></span>Más información de tu propiedad
        </h2>
      </div>
      <div class="masInfo-tabs container">
        <router-link
          :to="{
            name: 'detalle',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
        >
        <router-link
          :to="{
            name: 'estado-compra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'home']" />Estado de
          Compra</router-link
        >
        <router-link
          :to="{
            name: 'avance-obra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
          Obra</router-link
        >
        <router-link
          :to="{
            name: 'documentos',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'file']" />Documentos
          Negocio</router-link
        >
        <router-link
          :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'dollar-sign']" />Pagos</router-link
        >
        <router-link
          :to="{
            name: 'documentos-propiedad',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'map']" />Documentos
          Propiedad</router-link
        >
      </div>
    </section>
    <b-modal v-model="estadoObra" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <section class="seguimiento">
            <div class="seguimiento-info">
              <div class="seguimiento-info__status">
                <small
                  ><div class="status statusRed" />
                  Realizado</small
                >
                <small
                  ><div class="status statusOrange" />
                  Estado actual</small
                >
                <small
                  ><div class="status statusSkiBlue" />
                  Próximos pasos</small
                >
              </div>
            </div>
            <div class="seguimiento-timeline">
              <div
                v-for="timeItem in timelineItems"
                :key="timeItem.id"
                class="timeline__item"
              >
                <div
                  @click="timeItem.isOpen = true"
                  class="timeline__item-content"
                >
                  <div
                    class="timeline__item-icon"
                    :class="estilo(timeItem.id, avanceObra)"
                  >
                    <font-awesome-icon :icon="['fa', timeItem.icon]" />
                  </div>
                  <h6 class="timeline__item-title">{{ timeItem.title }}</h6>
                  <!-- <small class="timeline__item-date" v-if="timeItem.date.length > 0">{{
            timeItem.date
          }}</small> -->
                </div>
                <b-modal
                  v-model="timeItem.isOpen"
                  :width="640"
                  scroll="keep"
                  v-if="timeItem.status == 'realizado'"
                >
                  <div class="card">
                    <div class="card-content">
                      <h6 class="timeline__item-title">
                        {{ timeItem.title }}
                      </h6>
                      <!-- <small
                class="timeline__item-date"
                v-if="timeItem.date.length > 0"
                >{{ timeItem.date }}</small
              > -->
                      <p>{{ timeItem.desc }}</p>
                      <b-button v-if="timeItem.document == true"
                        >Descargar {{ timeItem.title }}
                        <font-awesome-icon :icon="['fa', 'download']"
                      /></b-button>
                    </div>
                  </div>
                </b-modal>
              </div>
              <div class="timeline-bar"></div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
    <section class="adBanner container">
      <img :src="images.family" alt="" />
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import {
  GET_PROJECTS,
  GET_PROJECT,
  GET_PROJECT_WP,
} from "@/core/services/store/proyecto.module";
moment.locale("es");

export default {
  name: "index",
  components: {},
  data() {
    return {
      avanceObra:0,
      estadoObra: false,
      images: {
        family: process.env.BASE_URL + "media/family.jpg",
        logo: process.env.BASE_URL + "media/logo.png",
      },
      estadoPropiedad: "",
      timelineItems: [
        {
          id: 1,
          status: "realizado",
          icon: "building",
          title: "Obra Finalizada",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
        {
          id: 2,
          status: "realizado",
          icon: "file-invoice",
          title: "Recepción Municipal ",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
        {
          id: 3,
          status: "enProceso",
          icon: "signature",
          title: "Copropiedad Inmobiliaria ",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
        {
          id: 4,
          status: "enEspera",
          icon: "file-alt",
          title:
            "Archivo de planos y documentos en Conservador de Bienes Raices",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
        {
          id: 5,
          status: "enEspera",
          icon: "pen-alt",
          title:
            "Envío de títulos legales y técnicos a Bancos e Instituciones Financieras",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
        {
          id: 6,
          status: "enEspera",
          icon: "file",
          title: "Inicio del proceso de Escrituración",
          isOpen: false,
          desc:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras placerat, ex et molestie auctor, purus nunc maximus ipsum, ac commodo libero mi quis augue. Integer id interdum urna. Cras tristique justo ac nulla feugiat bibendum. Donec vitae arcu nisi. Mauris eu scelerisque justo. Donec efficitur ex ipsum, a convallis orci finibus nec. Donec eget volutpat felis. Fusce id viverra enim, quis congue nulla. Proin sollicitudin venenatis nulla. Pellentesque ornare nibh in diam laoreet dignissim. Nam molestie felis at enim pretium placerat. Sed vestibulum ornare fermentum. Aliquam semper quis lorem vitae pellentesque. Vestibulum a mauris a odio tempor congue id dignissim metus.",
        },
      ],
      items: [
        {
          title: "Slide 1",
          image: "https://picsum.photos/id/0/1230/500",
        },
        {
          title: "Slide 2",
          image: "https://picsum.photos/id/1/1230/500",
        },
        {
          title: "Slide 3",
          image: "https://picsum.photos/id/2/1230/500",
        },
        {
          title: "Slide 4",
          image: "https://picsum.photos/id/3/1230/500",
        },
        {
          title: "Slide 5",
          image: "https://picsum.photos/id/4/1230/500",
        },
        {
          title: "Slide 6",
          image: "https://picsum.photos/id/5/1230/500",
        },
        {
          title: "Slide 7",
          image: "https://picsum.photos/id/6/1230/500",
        },
        {
          title: "Slide 8",
          image: "https://picsum.photos/id/7/1230/500",
        },
      ],
      loading: true,
      isOpen: false,
      isCardModalActive: false,
      status: [
        {
          id: 1,
          img: "https://bricsa.cl/img-sci/fachada/569.jpg",
          percent: "100",
          step: "Inicio de Escrituración",
          phase: "Etapa con entrega inmediata",
          date: "Inmediata",
        },
      ],
    };
  },
  mounted() {
    this.getProjects();
    this.getProject();
  },
  beforeRouteUpdate(to, from, next) {
    this.loading = true;
    this.$route.params.idNegocio = to.params.idNegocio;
    this.getProjects();
    this.getProject();
    this.isCardModalActive = false;
    next();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  methods: {
    estilo(etapa, actual){
      if(etapa<actual){
        return 'iconRed';
      } else if(etapa==actual){
        return 'iconOrange';
      }
      return 'iconSkiBlue;'
    },
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
    getProject() {
      const idNegocio = this.$route.params.idNegocio;
      this.project_wp.imagen = "";
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECT, idNegocio).then((response) => {
        const idProyecto = response.etapaNav.idProyecto;
        this.avanceObra = response.etapaNav.avanceObra;
        this.getProjectWp(idProyecto);
        this.$Progress.finish();
      });
    },
    getProjectWp(sci) {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECT_WP, sci).then(() => {
        this.$Progress.finish();
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      project: (state) => state.proyecto.project,
      project_wp: (state) => state.proyecto.project_wp,
      projects: (state) => state.proyecto.projects,
      productoPrincipal: function() {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == true;
        });
      },
      productos: function() {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == false;
        });
      },
      proyectos: function() {
        if (typeof this.projects.proyectos == "undefined") return [];
        console.log(
          "  +++ " +
            typeof this.projects.proyectos +
            " " +
            this.projects.proyectos
        );
        let elementos = this.projects.proyectos;
        elementos.forEach((item) => {
          item.productoPrincipal = item.productos.find((el) => {
            return el.esPrincipal == true ?? {};
          });
        });
        return elementos;
      },
      etapa:function(){
        if (typeof this.project == "undefined" || typeof this.project_wp == 'undefined'
        || typeof this.project_wp.etapas == 'undefined') return {
          imagenes:[{url:this.project_wp.imagen}]
        };
        let etapaActual = this.project_wp.etapas.find((el)=>{
          return el.nombre_etapa == this.project.etapaNav.codigoEtapa;
        });
        if (typeof etapaActual == "undefined") return {
          imagenes:[{url:this.project_wp.imagen}]
        };
        etapaActual.imagenes.push({url:this.project_wp.imagen});
        
        return etapaActual;
      },
    }),
    patenteErrors() {
      const errors = [];
      if (!this.$v.form.patente) return errors;
      !this.$v.form.patente.required && errors.push("Patente es requerido");
      !this.$v.form.patente.patenteEsValido &&
        errors.push("Patente no es válida");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.property {
  position: absolute;
  padding: 0 6.5%;
  top: 130px;
  z-index: 99;
  width: 100%;
  height: fit-content;
  left: 0;
  background-color: #f5f5f5;
  @media screen and(max-width:1025px) {
    position: fixed;
    top: 119px;
  }
  .property-title {
    h3 {
      color: #4a4a4a;
      font-weight: normal;
      font-size: 16px;
      text-align: left;
    }
    strong {
      color: var(--bricsa-red);
      margin-right: 5px;
    }
  }

  .card-header {
    padding: 10px 24px 5px 19.5px;
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
    .card-header-icon {
      color: var(--bricsa-red);
    }
  }
  .card-content {
    padding-top: 0;
    .content {
      display: grid;
      row-gap: 10px;
    }
  }
  .modal {
    .card-content {
      .misPropiedades-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .misPropiedades-content {
        display: grid;
        grid-template-columns: repeat(2, 49%);
        justify-content: space-between;
        row-gap: 10px;
        .misPropiedades-item {
          text-align: left;
          font-size: 13px;
          strong {
            color: var(--bricsa-red);
          }
        }
      }
    }
  }
  .property-buttonsGroup {
    display: grid;
    grid-template-columns: repeat(6, calc(90% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(3, 32%);
    }
    a {
      padding: 10px 15px;
      text-align: center;
      align-items: center;
      color: #7e7e7e;
      display: grid;
      grid-template-columns: 100%;
      justify-content: center;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      transition: 400ms;
      &:hover {
        background-color: #00457b;
        color: #fff;
      }
      @media screen and(max-width:1024px) {
        font-size: 12px;
      }
      @media screen and(max-width:426px) {
        padding: 5px;
      }
      svg {
        width: 100%;
        height: 30px;
        justify-self: center;
        color: #00457b;
        transition: 400ms;
        &:hover {
          color: #fff;
        }
        @media screen and(max-width:1024px) {
          height: 15px;
        }
      }
    }
    .change-btn {
      background-color: var(--bricsa-red);
      border-radius: 0;
      border: none;
      color: #fff;
      justify-self: flex-end;
      font-size: 14px;
      svg {
        margin-right: 10px;
      }
    }
  }
}
.avance {
  .bitacora {
    figure {
      position: relative;
    }
    .actualizacion {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 10px 15px;
      background: var(--bricsa-grey);
      color: #f5f5f5;
    }
  }
  .avance-title {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    margin-bottom: 20px;
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      span {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: var(--bricsa-red);
      }
    }
  }
}
.seguimiento {
  .seguimiento-title {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      span {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: var(--bricsa-red);
      }
    }
  }
  .seguimiento-info {
    .seguimiento-info__status {
      display: grid;
      grid-template-columns: repeat(3, max-content);
      column-gap: 10px;
      justify-content: center;
      small {
        display: flex;
        align-items: center;
        font-size: 16px;
      }
      .status {
        background-color: #707070;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        margin-right: 5px;
      }
      .statusRed {
        background-color: var(--bricsa-red);
      }
      .statusOrange {
        background-color: var(--bricsa-orange);
      }
      .statusSkiBlue {
        background-color: var(--bricsa-skiblue);
      }
    }
  }
  .seguimiento-timeline {
    position: relative;
    padding: 40px 0;
    display: grid;
    row-gap: 10px;
    column-gap: 10px;
    grid-template-columns: 190px 50px 190px;
    grid-template-rows: repeat(5, 53px);
    justify-content: center;
    align-items: center;
    .timeline__item {
      cursor: pointer;
      .timeline__item-content {
        display: grid;
        grid-template-columns: repeat(2, max-content);
        column-gap: 10px;
        .timeline__item-icon {
          grid-column: 1/2;
          grid-row: 1/3;
          width: 50px;
          height: 50px;
          background-color: var(--bricsa-skiblue);
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          svg {
            color: #fff;
            width: 20px;
            height: 20px;
          }
        }
        .iconRed {
          background-color: var(--bricsa-red);
        }
        .iconOrange {
          background-color: var(--bricsa-orange);
        }
        .iconSkiBlue {
          background-color: var(--bricsa-skiblue);
        }
        .timeline__item-title {
          width: 190px;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.1rem;
          color: var(--bricsa-grey);
          grid-row: 1/3;
          align-self: center;
        }
        .timeline__item-date {
          font-size: 12px;
          color: var(--bricsa-grey);
        }
      }
      .modal {
        text-align: left;
        .card-content {
          display: grid;
          row-gap: 10px;
          .button {
            background-color: var(--bricsa-red);
            border-radius: 0;
            border: none;
            color: #fff;
            justify-self: flex-start;
            font-size: 12px;
            svg {
              margin-left: 5px;
            }
          }
        }
        h6 {
          font-weight: bold;
        }
        p {
          font-size: 14px;
        }
      }
    }
    .timeline-bar {
      position: absolute;
      top: 10%;
      left: 20px;
      z-index: -1;
      grid-column: 2/3;
      grid-row: 1/6;
      width: 10px;
      height: 100%;
      background-color: #e7e7e7;
      border-radius: 5px;
    }
  }
  .timeline__item:nth-child(even) {
    text-align: right;
    grid-column: 1/3;
    .timeline__item-content {
      .timeline__item-icon {
        grid-column: 2/3;
        grid-row: 1/3;
      }
    }
  }
  .timeline__item:nth-child(odd) {
    justify-self: flex-end;
    grid-column: 2/4;
    text-align: left;
  }
}
.status {
  .status-content {
    .status-item {
      display: grid;
      grid-template-columns: repeat(2, 48%);
      justify-content: space-between;
      align-items: flex-end;
      @media screen and (max-width: 1024px) {
        grid-template-columns: 100%;
        row-gap: 20px;
      }
      img {
        padding-right: 20px;
        border-right: solid 20px var(--bricsa-orange);
      }
      .status-item__info {
        width: 70%;
        justify-self: center;
        text-align: left;
        font-family: Roboto, sans-serif;
        @media screen and (max-width: 1024px) {
          width: 100%;
        }
        .status-step {
          display: grid;
          grid-template-columns: 40% 55%;
          justify-content: space-between;
          border-bottom: solid 5px var(--bricsa-orange);
          strong {
            color: var(--bricsa-orange);
            font-size: 56px;
            grid-row: 1/3;
            align-self: center;
          }
          label {
            font-weight: bold;
            font-size: 24px;
            line-height: 1.2;
          }
          p {
            font-size: 20px;
          }
        }
        .status-date {
          h2 {
            font-size: 26px;
            font-weight: 300;
          }
          h1 {
            font-weight: 500;
            font-size: 36px;
          }
        }
      }
    }
  }
}
.masInfo {
  margin-top: 50px;
  .masInfo-title {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      span {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: var(--bricsa-red);
      }
    }
  }
  .masInfo-tabs {
    display: grid;
    grid-template-columns: repeat(6, 16%);
    justify-content: space-between;
    padding: 3% 5%;
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(3, 32%);
    }
    .masInfo-tabs__item {
      font-size: 10px;
      padding: 10px;
      height: 100%;
      text-align: center;
      font-weight: bold;
      border: none;
      border-radius: 0px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      color: var(--bricsa-skiblue);
      align-items: center;
      svg {
        @media screen and (max-width: 769px) {
          height: 15px;
        }
      }
    }
  }
}

.adBanner {
  width: 100%;
  img {
    width: 100%;
    height: 350px;
    object-fit: cover;
    object-position: center 30%;
    @media screen and(max-width:1025px) {
      height: 150px;
    }
  }
}
</style>
